module.exports = __webpack_public_path__ + "img/xroad7_large.98a680e4.png";